import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { resourceIdZodSchema } from "../resource-id";

const resourceTableGroupEditCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_TABLE_GROUP_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    resourceId: resourceIdZodSchema,
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    subtitle: translatableZodSchema.optional(),
    description: translatableZodSchema.optional(),
    kicker: translatableZodSchema.optional(),
    type: z.literal("RESOURCE_TABLE_GROUP"),
    resourceIds: z.array(resourceIdZodSchema),
    allowMultipleCheckIns: z.boolean(),
    checkInEnabled: z.boolean(),
    quantity: z.number().int().positive(),
});
type ResourceTableGroupEditCommand = z.infer<
    typeof resourceTableGroupEditCommandZodObject
>;

const resourceTableGroupEditCommandFactoryParamsZodObject =
    resourceTableGroupEditCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<
    typeof resourceTableGroupEditCommandFactoryParamsZodObject
>;
const resourceTableGroupEditCommandFactory = (params: FactoryParams) => {
    const ResourceTableGroupEditCommand: ResourceTableGroupEditCommand = {
        ...params,
        _id: generateId({ prefix: "resource_group_edit_command__" }),
        _type: "RESOURCE_TABLE_GROUP_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return ResourceTableGroupEditCommand;
};

export {
    resourceTableGroupEditCommandFactory,
    resourceTableGroupEditCommandFactoryParamsZodObject,
    resourceTableGroupEditCommandZodObject,
};
export type {
    ResourceTableGroupEditCommand,
    FactoryParams as ResourceTableGroupEditCommandFactoryParams,
};
